import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ebyk25ji57: FaireBrandEntity = {
  token: "b_ebyk25ji57",
  type: "brand",
  name: "OAT COLLECTIVE",
  avatarUrl:
    "https://cdn.faire.com/fastly/870adb9bf804e583a7e05faa247096f484c5d6fcfb395a652e217eb950b694c1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/89f0946f3d73bbc568bb9906c5fcde42ddaab4e434ef1ad47011d01f2157a86d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/870adb9bf804e583a7e05faa247096f484c5d6fcfb395a652e217eb950b694c1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/89f0946f3d73bbc568bb9906c5fcde42ddaab4e434ef1ad47011d01f2157a86d.jpeg",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 99,
  rating: 4.9,
  reviewCount: 1297,
  isTopShop: true,
  isInsider: true,
  description:
    "\nDear Valued Customer,\n\nOat Collective is a Christian Young Contemporary manufacturer and wholesaler of on-trend quality tees focused on everyday lifestyle Apparel. We hope to share hope and love through your everyday wardrobe. Orders will be Shipped 7-14 working days excluding Holidays & weekends. Any orders placed after or before the holidays may cause delays but will be prepped the same way to be shipped as fast as possible. Thanks for your support and understanding :)\nFeel free to message us with any questions or concerns. We are here for you. It's our honor and privilege to serve you, and we thank you for being at the heart of what we do.\n\nPlease stay safe and God Bless.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:43.684Z",
    importedBy: "entity-db-cli",
  },
};
